import client from '../client';
import type {
  IDeleteProdoqRoleParams,
  IGetProdoqCompaniesParams,
  IPatchProdoqCompanyParams,
  IPostProdoqRoleParams,
  IPutProdoqPermissionsParams,
  IPutProdoqRoleParams,
  IProdoqCompanyIdParams,
} from './types';

export const prodoqApis = {
  getProdoqCompanies: ({ searchType, searchWord, pg, pgSize }: IGetProdoqCompaniesParams) =>
    client.get(`/prodoq/companies`, {
      params: { searchType, keyword: searchWord, pg, pgSize },
    }),
  getProdoqMenuList: () => client.get('/v1/users/menus'),
  getProdocqRolesByCompany: (data: IProdoqCompanyIdParams) => client.get(`/prodoq/companies/${data.companyId}/roles`),
  getProdocqPermissionsByCompany: (data: IProdoqCompanyIdParams) => client.get(`/prodoq/companies/${data.companyId}/permissions`),
  postRole: (data: IPostProdoqRoleParams) =>
    client.post(`/prodoq/companies/${data.companyId}/roles`, {
      order: data.order,
      roleName: data.roleName,
      roleNameEn: data.roleNameEn,
    }),
  putRole: (data: IPutProdoqRoleParams) => client.put(`/prodoq/companies/${data.companyId}/roles/${data.roleId}`, data),
  deleteRole: (data: IDeleteProdoqRoleParams) => client.delete(`/prodoq/companies/${data.companyId}/roles/${data.roleId}`),
  patchProdoqCompany: (data: IPatchProdoqCompanyParams) => client.patch(`/prodoq/companies/${data.companyId}`, data.data),
  putPermission: (data: IPutProdoqPermissionsParams) => client.put(`/prodoq/companies/${data.companyId}/permissions`, data.data),
};
